import React from "react";
import { ReactComponent as Chat } from "assets/chatBotIcon.svg";

import styled from "styled-components";

type Props = {
  style?: React.CSSProperties;
  fill?: string;
};

export const ChatIcon = ({ style, fill }: Props) => {
  return (
    <Container style={style}>
      <Icon fill={fill} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.purpleDark};
  padding: 10px;
  border-radius: 50%;
`;
const Icon = styled(Chat)<{ fill?: string }>`
  ${({ fill }) => fill && `fill: ${fill};`}
`;
